// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__Kip8i","heading":"Title_heading__lfYhW","applicationNumber":"Title_applicationNumber__xk5LL"};